import {Component, Input, OnInit} from '@angular/core';
import {Host} from "../../../../common";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'home-greeter',
  standalone: false,
  template: `
    <div class="home-greeter mt-2">
      <div *ngIf="customMarkup" [innerHtml]="customMarkup"></div>
      <div class="host-logo-wrap" *ngIf="!customMarkup">
        <img *ngIf="host.logo" class="img-fluid mx-auto d-block" [src]="host.logo" [alt]="host.name +': Logo'"/>
        <p *ngIf="hostText" class="text-center">{{ hostText }}</p>
      </div>
    </div>
  `
})

export class HomeGreeter implements OnInit {

  @Input() host: Host;

  customMarkup: SafeHtml = null;
  hostText: string = null;

  constructor(
    private sanitizer: DomSanitizer
  ) {}

  isHtml(str: string): boolean {
    return str==='&nbsp;' || str.includes('<') && str.includes('</');
  }

  ngOnInit(): void {
    if (this.isHtml(this.host.greeting)) {
      this.customMarkup =  this.sanitizer.bypassSecurityTrustHtml(this.host.greeting);
    } else {
      this.hostText = this.host.greeting;
    }

  }

}
